export default "__VITE_ASSET___IKxGgqb__"